export default function (state, getters, rootState, rootGetters) {
    return rootGetters['dictionaries/paymentAccount/select/list'];
}